import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/enjazfile/users',
      name: 'enjazfile/users',
      component: () => import('@/views/enjazfile/users.vue')
    },
    {
      path: '/enjazfile/orders',
      name: 'enjazfile/orders',
      component: () => import('@/views/enjazfile/orders.vue')
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/posts',
      name: 'posts',
      component: () => import('@/views/posts.vue')
    },
    {
      path: '/feedback/type/feedback',
      name: 'feedback1',
      component: () => import('@/views/feedbacks.vue')
    },
    {
      path: '/ticket/:id',
      name: 'ticket',
      component: () => import('@/views/ticket.vue')
    },
    {
      path: '/feedback/type/ticket',
      name: 'feedback2',
      component: () => import('@/views/feedbacks.vue')
    },
    {
      path: '/calls',
      name: 'calls',
      component: () => import('@/views/calls.vue')
    },
    {
      path: '/new-year',
      name: 'new-year',
      component: () => import('@/views/new-year.vue')
    },
    {
      path: '/ups',
      name: 'ups',
      component: () => import('@/views/ups.vue')
    },
    {
      path: '/ai-chats',
      name: 'ai-chats',
      component: () => import('@/views/ai-chats.vue')
    },
    {
      path: '/ai-settings',
      name: 'ai-settings',
      component: () => import('@/views/ai-settings.vue')
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/users.vue')
    },
    {
      path: '/resellers',
      name: 'resellers',
      component: () => import('@/views/resellers.vue')
    },
    {
      path: '/devices',
      name: 'devices',
      component: () => import('@/views/devices.vue')
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/settings.vue')
    },
    {
      path: '/app-versions',
      name: 'app-versions',
      component: () => import('@/views/app-versions.vue')
    },
    {
      path: '/app-messages',
      name: 'app-messages',
      component: () => import('@/views/app-messages.vue')
    },
    {
      path: '/app-push',
      name: 'app-push',
      component: () => import('@/views/app-push.vue')
    },
    {
      path: '/app-tutorials',
      name: 'app-tutorials',
      component: () => import('@/views/app-tutorials.vue')
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('@/views/orders.vue')
    },
    {
      path: '/freedays',
      name: 'freedays',
      component: () => import('@/views/freedays.vue')
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('@/views/services.vue')
    },
    {
      path: '/todo',
      name: 'todo',
      component: () => import('@/views/resellers_todo.vue')
    },
    {
      path: '/visits',
      name: 'visits',
      component: () => import('@/views/resellers_visits.vue')
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import('@/views/resellers_calendar.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/pages/login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/views/pages/logout.vue')
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      name: 'error-4042',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
